import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from "react-alert";
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },

}));

const screenCode = 'CASHDENOMINATIONREPORT';

export default function CashDenominationReport(props) {
  const [title, setTitle] = useState("Cash Denomination Report");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [denominationdetails, setDenominationdetails] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    year: '',
    month: ''
  });
  const [denominationCropData, setDenominationCropData] = useState([]);
  const [prevTotalAmount, setPrevTotalAmount] = useState(0);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    monthName: '',
    factoryName: "0",
    routeName: "0",
    groupName: '0'
  })
  const [csvHeaders, SetCsvHeaders] = useState([])
  const [cashCountList, setCashCountList] = useState([]);
  const [coinTotal, setCoinTotal] = useState([]);
  const [remainingValueTotal, setRemainingValueTotal] = useState(0);
  const [lastBalancePaymentRunDate, setLastBalancePaymentRunDate] = useState();
  const cash = ['5000', '1000', '500', '100', '50', '20'];
  const columnTitles = ['Route Name', ...cash, 'Amount(Rs)'];
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);

  const mergedData = cashCountList.reduce((acc, curr) => {
    const existing = acc.find(item => item.routeName === curr.routeName);
    if (existing) {
      existing.cashCount.forEach((coin, index) => {
        coin.coinCount += curr.cashCount[index].coinCount;
      });
      existing.amount += curr.amount;
    } else {
      acc.push({ ...curr, cashCount: curr.cashCount.map(coin => ({ ...coin })) });
    }
    return acc;
  }, []);


  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    if (denominationdetails.groupID != 0) {
      trackPromise(
        getFactoriesForDropdown());
    }
    setCashCountList([]);
  }, [denominationdetails.groupID]);

  useEffect(() => {
    if (denominationdetails.factoryID != 0)
      trackPromise(getRoutesByFactoryID());
    setCashCountList([]);
    trackPromise(
      GetLastBalancePaymentExecutionDetails());
  }, [denominationdetails.factoryID]);

  useEffect(() => {
    setCashCountList([]);
  }, [denominationdetails.routeID]);

  useEffect(() => {
    setCashCountList([]);
  }, [denominationdetails.month]);

  useEffect(() => {
    setSelectedDate(lastBalancePaymentRunDate);
  }, [lastBalancePaymentRunDate]);

  useEffect(() => {
    setDenominationdetails((prev) => ({
      ...prev,
      routeID: 0
    }))
  }, [denominationdetails.groupID, denominationdetails.factoryID])

  useEffect(() => {
    setCashCountList([])
  }, [denominationdetails.month, denominationdetails.year])

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCASHDENOMINATIONREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setDenominationdetails({
      ...denominationdetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(denominationdetails.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(denominationdetails.factoryID);
    setRoutes(routeList);
  }

  async function GetDenominationDetails() {
    let totalAmount = 0;

    const denominationData = await GetDenominationDetailsList();

    if (denominationData.statusCode == "Success" && denominationData.data != null) {
      setDenominationCropData(denominationData.data);
      calculateCashCount(denominationData.data, cash)
      denominationData.data.forEach(x => {
        totalAmount = totalAmount + parseFloat(x.amount);
      });
      setPrevTotalAmount(totalAmount);
      createDataForExcel(denominationData.data);

      if (denominationData.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(denominationData.message);

    }
  }

  async function GetDenominationDetailsList() {
    let model = {
      groupID: parseInt(denominationdetails.groupID),
      factoryID: parseInt(denominationdetails.factoryID),
      routeID: parseInt(denominationdetails.routeID),
      applicableMonth: (selectedDate.getMonth() + 1).toString().padStart(2, "0"),
      applicableYear: selectedDate.getFullYear().toString()
    };
    getSelectedDropdownValuesForReport(model);

    const denominationData = await services.GetCashDenominationReportDetails(model);
    return denominationData;
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setDenominationdetails({
      ...denominationdetails,
      [e.target.name]: value
    });
    setDenominationCropData([]);
  }

  function handleDateChange(date) {
    let monthNames = ["JAN", "FEB", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUG", "SEPT", "OCT", "NOV", "DEC"];
    var month = date.getUTCMonth() + 1; //months from 1-12
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');
    let monthName = monthNames[month - 1];
    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName
    })
    setDenominationdetails({
      ...denominationdetails,
      month: month.toString(),
      year: year.toString()
    });

    if (selectedDate != null) {

      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
      }
    } else {
      setSelectedDate(date)
    }
    setDenominationCropData([]);
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array && array.length > 0) {
      const mergedData = array.reduce((acc, curr) => {
        if (!curr || !curr.routeName) return acc;

        const existing = acc.find(item => item.routeName === curr.routeName);
        if (existing) {
          existing.cashCount.forEach((coin, index) => {
            if (curr.cashCount && curr.cashCount[index]) {
              coin.coinCount += curr.cashCount[index].coinCount || 0;
            }
          });
          existing.amount += curr.amount || 0;
        } else {
          acc.push({
            ...curr,
            cashCount: Array.isArray(curr.cashCount)
              ? curr.cashCount.map(coin => ({ ...coin }))
              : Array(6).fill({ coinCount: 0 })
          });
        }
        return acc;
      }, []);

      mergedData.forEach(x => {
        res.push({
          'Route Name': x && x.routeName,
          'FiveThousands(5000)': x && x.cashCount && x.cashCount[0] && x.cashCount[0].coinCount,
          'Thousands(1000)': x && x.cashCount && x.cashCount[1] && x.cashCount[1].coinCount,
          'FiveHundreds(500)': x && x.cashCount && x.cashCount[2] && x.cashCount[2].coinCount,
          'Hundreds(100)': x && x.cashCount && x.cashCount[3] && x.cashCount[3].coinCount,
          'Fifties(50)': x && x.cashCount && x.cashCount[4] && x.cashCount[4].coinCount,
          'Twenties(20)': x && x.cashCount && x.cashCount[5] && x.cashCount[5].coinCount,
          'Amount(Rs)': x && x.amount && x.amount

        });
      });
      res.push({});
      var vr = {
        'Route Name': "Total",
        'FiveThousands(5000)': coinTotal && coinTotal[0] && coinTotal[0].coinCount,
        'Thousands(1000)': coinTotal && coinTotal[1] && coinTotal[1].coinCount,
        'FiveHundreds(500)': coinTotal && coinTotal[2] && coinTotal[2].coinCount,
        'Hundreds(100)': coinTotal && coinTotal[3] && coinTotal[3].coinCount,
        'Fifties(50)': coinTotal && coinTotal[4] && coinTotal[4].coinCount,
        'Twenties(20)': coinTotal && coinTotal[5] && coinTotal[5].coinCount,
        'Amount(Rs)': prevTotalAmount
      }
      res.push(vr);

      res.push({});

      var vr = {
        'Route Name': 'Group :' + selectedSearchValues.groupName,
        'FiveThousands(5000)': 'Factory :' + selectedSearchValues.factoryName
      }
      res.push(vr);

      const month = selectedDate.getMonth() + 1;
      const year = selectedDate.getFullYear();
      const monthYearString = `${month}/${year}`;
      var vr = {
        'Route Name': selectedSearchValues.routeName !== undefined ? "Route :" + selectedSearchValues.routeName : "Route : All Route",
        'FiveThousands(5000)': 'Year and Month :' + monthYearString,
      }
      res.push(vr);
    }
    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(cashCountList);
    var settings = {
      sheetName: 'Cash Denomination Report',
      fileName: 'Cash Denomination Report ' + selectedSearchValues.factoryName + '-' + selectedSearchValues.routeName + '-'
        + ((denominationdetails.year === '' ? moment(new Date()).format('YYYY') : denominationdetails.year) - 1) + '/' + (denominationdetails.month === '' ? moment(new Date()).format('MMM') : selectedSearchValues.monthName) + '-'
        + (denominationdetails.year === '' ? moment(new Date()).format('YYYY') : denominationdetails.year) + '/' + (denominationdetails.month === '' ? moment(new Date()).format('MMM') : selectedSearchValues.monthName),
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Cash Denomination Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routes[searchForm.routeID],
      year: searchForm.year,
      groupName: GroupList[searchForm.groupID]
    })
  }

  function calculateCashCount(registrationList, cash) {
    const coinNames = {
      5000: 'fiveThousand',
      1000: 'oneThousand',
      500: 'fiveHundred',
      100: 'oneHundred',
      50: 'fifty',
      20: 'twenty'
    };

    const cashCountList = registrationList.map((registration) => {
      let amount = registration.amount;
      let cashCount = [];
      let coinTotal = {};

      const evaluationNote = 50;
      const dividerNote = 20;

      let remainingValue = 0;
      let numberOfCoins = 0;

      for (let index = 0; index < cash.length; index++) {

        if (parseInt(cash[index]) === evaluationNote) {
          const reminderEvaluation = amount % dividerNote;
          if (reminderEvaluation == 0) {
            remainingValue = amount % dividerNote;
            numberOfCoins = 0;
          } else {
            numberOfCoins = Math.trunc(amount / cash[index]);
          }
        } else {
          numberOfCoins = Math.trunc(amount / cash[index]);
        }

        cashCount.push({
          coinNumber: cash[index],
          coinCount: numberOfCoins,
        });

        if (numberOfCoins === 0) {
          continue;
        }

        let totDeduction = numberOfCoins * cash[index];
        amount -= totDeduction;

        if (coinTotal[coinNames[cash[index]]]) {
          coinTotal[coinNames[cash[index]]] += numberOfCoins;
        } else {
          coinTotal[coinNames[cash[index]]] = numberOfCoins;
        }
      }

      remainingValue = amount.toFixed(2);

      return {
        routeName: registration.routeName,
        amount: registration.amount,
        registrationNumber: registration.registrationNumber,
        cashCount: cashCount,
        remainingValue: remainingValue,
        coinTotal: coinTotal,
      };
    });

    let coinTotal = {};
    for (let i = 0; i < cashCountList.length; i++) {
      let cashCountObj = cashCountList[i];
      let cashCountArr = cashCountObj.cashCount;
      for (let j = 0; j < cashCountArr.length; j++) {
        let coinNumber = cashCountArr[j].coinNumber;
        let coinCount = cashCountArr[j].coinCount;
        if (coinTotal[coinNames[coinNumber]]) {
          coinTotal[coinNames[coinNumber]] += coinCount;
        } else {
          coinTotal[coinNames[coinNumber]] = coinCount;
        }
      }
    }
    const coinTotalArray = Object.entries(coinTotal).map(([coinValue, coinCount]) => ({
      coinName: coinNames[coinValue],
      coinCount: coinCount,
    }));
    const totalRemainingValue = cashCountList.reduce((total, cashCountObj) => {
      return total + parseFloat(cashCountObj.remainingValue);
    }, 0).toFixed(2);

    setRemainingValueTotal(totalRemainingValue);
    setCoinTotal(coinTotalArray);
    setCashCountList(cashCountList);
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const getPageMargins = () => {
    return `@media print {
      @page {
          size: A4 Protrait ;
          background-color: white !important;
          padding:2px
      }
 
      body {
          size: A4 Protrait ;
          background-color: white !important;
      }
  }`;
  }

  async function GetLastBalancePaymentExecutionDetails() {
    let response = await services.GetLastBalancePaymentExecutionDetails(denominationdetails.groupID, denominationdetails.factoryID);
    if (response.statusCode === 'Success' && response.data != null) {
      let { applicableYear, applicableMonth } = response.data;
      let date = new Date(Number(applicableYear), Number(applicableMonth) - 1);
      setLastBalancePaymentRunDate(date);
    }
  }

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: denominationdetails.groupID,
              factoryID: denominationdetails.factoryID,
              routeID: denominationdetails.routeID,
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={() => trackPromise(GetDenominationDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={denominationdetails.groupID}
                              variant="outlined"
                              id="groupID"
                              size='small'
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={denominationdetails.factoryID}
                              variant="outlined"
                              id="factoryID"
                              size='small'
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.routeID && errors.routeID)}
                              fullWidth
                              helperText={touched.routeID && errors.routeID}
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={denominationdetails.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                helperText="Select applicable month"
                                value={selectedDate}
                                onChange={(date) => handleDateChange(date)}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1000}>
                        {cashCountList.length > 0 ?
                          <TableContainer>
                            <Table aria-label="caption table" size='small'>
                              <TableHead>
                                <TableRow>
                                  {columnTitles.map((title, index) => (
                                    <TableCell key={title} align={index === 0 ? "left" : index === columnTitles.length - 1 ? "right" : "center"}
                                      style={{ border: '1px solid #ccc', fontWeight: 'bold' }}>
                                      {index !== 0 && index !== columnTitles.length - 1 ? `Rs. ${title}` : title}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {mergedData.slice(page * limit, page * limit + limit).map((data, index) => (
                                  <TableRow key={index}>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}>
                                      {data.routeName}
                                    </TableCell>
                                    {data.cashCount.map((coin, index) => (
                                      <TableCell key={cash[index]} component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }}>
                                        {coin.coinCount}
                                      </TableCell>
                                    ))}
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }}>
                                      {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              <TableRow>
                                <TableCell align={'left'} style={{ border: '1px solid #ccc', fontWeight: 'bold' }}>Total</TableCell>
                                {coinTotal.map((coin, index) => (
                                  <TableCell key={cash[index]} component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }}>
                                    <b>{coin.coinCount}</b>
                                  </TableCell>
                                ))}
                                <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc', textAlign: "right", paddingRight: "20px" }}>
                                  <b>{prevTotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                </TableCell>
                              </TableRow>
                            </Table><TablePagination
                              component="div"
                              count={denominationCropData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                          : null
                        }
                      </Box>
                      <Divider />
                      {denominationCropData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size='small'
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"Cash Denomination Report"}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              cashCountList={cashCountList} coinTotal={coinTotal} remainingValueTotal={remainingValueTotal}
                              selectedSearchValues={selectedSearchValues} searchDate={denominationdetails} prevTotalAmount={prevTotalAmount}
                              coinNames={cash} columnTitles={columnTitles} mergedData={mergedData} selectedDate={selectedDate}
                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
